export const iconFontAwesomeArrowsArrowsTurnToDots = (
	<i className="fa-solid fa-arrows-turn-to-dots"></i>
);
